// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vz-z","smallCardRow":"wz-z","largeCardRow":"xz-z","productSearchRow":"yz-z","curatedRow":"zz-z"};